import impressionStats from "./impressionStats";
import { nationalStats } from "./nationalStats";

// name: should match object key, camelCase, no special characters, used as key, id, route slug, color
export const narrativeStats = {
    'all': {
        name: 'all',
        display: 'All Campaigns',
        mobileDisplay: 'All',
        description: '',
        stats: [
            {
                name: 'candidates and causes',
                count: nationalStats.races.total.count,
            },

            {
                name: nationalStats.races.senate_w.count > 1 ? 'U.S. Senators elected' : "U.S. Senator elected",
                count: nationalStats.races.senate_w.count,
            },

            {
                name: nationalStats.races.representative_w.count > 1 ? 'U.S. Representatives elected' : "U.S. Representative elected",
                count: nationalStats.races.representative_w.count,
            },

            {
                name: nationalStats.narratives.flipped ? 'seats flipped' : "seat flipped",
                count: nationalStats.narratives.flipped,
            },
            {
                name: 'DSPolitical Ad Grant Recipients elected',
                count: 7
            }
        ],
        to: 'all'
    },
    'technology': {
        name: 'technology',
        display: 'Technology',
        mobileDisplay: 'Tech',
        description: 'The tools and technology that powered campaigns up and down the ballot. DSPolitical is proud to have served digital ads in all 50 states at a greater scale than ever before!',
        stats: [
            {
                name: 'impressions',
                title: 'Impressions',
                color: 'technology',
                narrative: 'technology',
                count: impressionStats.total
            },
            {
                name: 'total audience records matched & targeted',
                title: 'Total Audience Records Matched & Targeted',
                color: 'technology',
                narrative: 'technology',
                count: 469550650
            },
            {
                name: 'AVEV voters excluded automatically',
                title: 'AVEV Voters Excluded Automatically',
                color: 'technology',
                narrative: 'technology',
                count: 81331413
            },
            {
                name: 'running line items across all products',
                title: 'Running Line Items Across All Products',
                color: 'technology',
                narrative: 'technology',
                count: 7046
            },
            {
                name: 'campaigns launched from our new media planning tool',
                title: 'Campaigns Launched from our New Media Planning Tool',
                color: 'technology',
                narrative: 'technology',
                count: 235
            },
            {
                name: "of all media run on CTV",
                title: "Of All Media Run on CTV",
                color: 'technology',
                narrative: 'technology',
                count: 53,
                isPercent: true
            },
        ],
        to: 'technology'
    },
    'aapi': {
        name: 'aapi',
        display: 'AAPI',
        title: 'AAPI Candidates',
        mobileDisplay: 'AAPI',
        description: '',
        stats: [
            {
                name: nationalStats.narratives.aapi > 1 ? "AAPI candidates" : "AAPI candidate",
                count: nationalStats.narratives.aapi
            },
            {
                name: "AAPI candidates elected to the U.S. House",
                count: 4
            },
            {
                name: "AAPI senators elected",
                count: 2
            },
            {
                name: "AAPI candidates elected to state legislatures",
                count: 46
            },
        ],
        to: 'aapi'
    },
    'black': {
        name: 'black',
        display: 'Black',
        title: 'Black Candidates',
        mobileDisplay: 'Black',
        description: '',
        stats: [
            {
                name: nationalStats.narratives.black > 1 ? "Black candidates" : "Black candidate",
                count: nationalStats.narratives.black
            },
            {
                name: "Black candidates elected to state legislatures",
                count: 160
            },
            {
                name: "Black candidates elected to the U.S. House",
                count: 18
            },
            {
                name: "Black women candidates elected",
                count: 123
            },
        ],
        to: 'black'
    },
    'flipped': {
        name: 'flipped',
        display: 'Flipped',
        mobileDisplay: 'Flipped',
        description: 'DSPolitical is committed to helping Democrats and Progressives take back government, one seat at a time.',
        stats: [
            {
                name: 'seats flipped',
                count: nationalStats.narratives.flipped
            },
        ],
        to: 'flipped'
    },
    'gotv': {
        name: 'gotv',
        display: 'GOTV',
        mobileDisplay: 'GOTV',
        description: 'In collaboration with our partners, DSPolitical helped drive historic voter turnout in key battleground states with GOTV programs designed to help turn out the vote!',
        stats: [
            {
                name: nationalStats.narratives.gotv > 1 ? 'GOTV programs' : 'GOTV program',
                count: nationalStats.narratives.gotv
            }
            // {
            //     name: 'state GOTV programs',
            //     count: '36'
            // },
            //
            // {
            //     name: 'national GOTV programs',
            //     count: '36'
            // },
            //
            // {
            //     name: 'digital GOTV campaigns nationwide',
            //     count: '279+'
            // },

        ],
        to: 'gotv'
    },
    'latino': {
        name: 'latino',
        display: 'Latino',
        title: 'Latino Candidates',
        mobileDisplay: 'Latino',
        description: '',
        stats: [
            {
                name: nationalStats.narratives.latino > 1 ? 'Latino candidates' : "Latino candidate",
                count: nationalStats.narratives.latino
            },
            {
                name: "Latina women candidates elected",
                count: 57
            },
            {
                name: "Latino candidates elected to state legislatures",
                count: 67
            },
            {
                name: "Latino candidates elected to the U.S. House",
                count: 11
            },
        ],
        to: 'latino'
    },
    'lgbtq': {
        name: 'lgbtq',
        display: 'LGBTQ+',
        title: 'LGBTQ+ Candidates',
        mobileDisplay: 'LGBTQ+',
        description: 'The only way to ensure equal rights for LGBTQ+ Americans is to ensure they are equally represented in the halls of power.',
        stats: [
            {
                name: nationalStats.narratives.lgbtq > 1 ? 'LGBTQ+ candidates' : "LGBTQ+ candidate",
                count: nationalStats.narratives.lgbtq
            },
            {
                name: "LGBTQ+ candidates of color ran for office",
                count: 34
            },
            {
                name: "LGBTQ+ candidates elected to the U.S. House",
                count: 5
            },
            {
                name: "LGBTQ+ candidates elected to state legislatures",
                count: 53
            },
        ],
        to: 'lgbtq'
    },
    'native_american': {
        name: 'native_american',
        display: 'Native American',
        title: 'Native American Candidates',
        mobileDisplay: 'Native American',
        description: '',
        stats: [
            {
                name: nationalStats.narratives.native_american > 1 ? 'Native American candidates' : "Native American candidate",
                count: nationalStats.narratives.native_american
            },
            {
                name: "Native American candidates elected",
                count: 14
            },
            {
                name: "Native American candidates elected to State Houses",
                count: 10
            },
            {
                name: "Native American women elected",
                count: 7
            },
        ],
        to: 'native_american'
    },
    'new': {
        name: 'new',
        display: 'First Time Candidates',
        mobileDisplay: 'First Time',
        description: 'A new America needs new blood in office, so DSPolitical is proud of its commitment to helping Democrats win new seats.',
        stats: [
            {
                name: nationalStats.narratives.new > 1 ? 'first time candidates' : "first time candidate",
                count: nationalStats.narratives.new
            },
            {
                name: "first time candidates of color elected",
                count: 52
            },
            {
                name: "first time candidates flipped their seats from Red to Blue",
                count: 22
            },
        ],
        to: 'new'
    },
    'poc': {
        name: 'poc',
        display: 'People of Color',
        title: 'Candidates of Color',
        mobileDisplay: 'POC',
        description: 'Representation matters, and we‘re proud to help candidates of color win elected office.',
        stats: [
            {
                name: nationalStats.narratives.poc > 1 ? 'people of color' : 'person of color',
                count: nationalStats.narratives.poc
            },
            {
                name: 'women of color elected',
                count: 205
            },
            {
                name: 'people of color ran for office for their first time',
                count: 124
            },
            {
                name: nationalStats.narratives.black > 1 ? 'Black candidates' : "Black candidate",
                count: nationalStats.narratives.black
            },
            {
                name: nationalStats.narratives.latino > 1 ? 'Latino candidates' : "Latino candidate",
                count: nationalStats.narratives.latino
            },
            {
                name: nationalStats.narratives.aapi > 1 ? 'AAPI candidates' : "AAPI candidate",
                count: nationalStats.narratives.aapi
            },
            {
                name: nationalStats.narratives.native_american > 1 ? 'Native American candidates' : "Native American candidate",
                count: nationalStats.narratives.native_american
            },
        ],
        to: 'poc'
    },
    'women': {
        name: 'women',
        display: 'Women',
        title: 'Women Candidates',
        mobileDisplay: 'Women',
        description: 'With more Democratic women running for office than ever before, DSPolitical is proud to help power them to victory.',
        stats: [
            {
                name: nationalStats.narratives.women > 1 ? 'women ran for office' : "woman ran for office",
                count: nationalStats.narratives.women
            },
            {
                name: 'women elected',
                count: 528
            },
            {
                name: 'women elected to the U.S. House',
                count: 33
            },
            {
                name: 'women senators elected',
                count: 8
            },
            {
                name: 'women elected to State Houses',
                count: 309
            },
            {
                name: 'women judges elected',
                count: 10
            },
            {
                name: 'women of color elected',
                count: 205
            },
        ],
        to: 'women'
    },
};